import PropTypes from 'prop-types';

import Chip from '@zenbusiness/zui/Chip';

import * as Styled from './MenuItem.style';
import { Icon } from '../Icon';
import { MenuItemProps } from './utils/contants';

export default function MenuItemBody({
  icon,
  isBeta,
  isChild,
  newItem,
  title
}) {
  return (
    <>
      {!!icon && (
        <Icon
          className="tile"
          src={icon}
        />
      )}

      <Styled.Text
        size="sm"
        weight={isChild ? 'regular' : 'medium'}
        component="span"
      >
        {title}
      </Styled.Text>

      {newItem && (
        <Chip
          className="new-flag"
          color="success"
          label="New"
        />
      )}

      {isBeta && (
        <Chip
          className="new-flag"
          color="secondary"
          label="Beta"
        />
      )}
    </>
  );
}

MenuItemBody.propTypes = {
  icon: MenuItemProps.icon,
  isChild: PropTypes.bool,
  isBeta: MenuItemProps.isBeta,
  newItem: MenuItemProps.newItem,
  title: MenuItemProps.title
};
